import type {
  ProductCategory,
  ProductKind,
  ProductType,
} from '@iheartjane/types';

import { ROOT_SUBTYPE_PATHS, URL_ROOT } from './constants';

interface Args {
  category?: ProductCategory | null;
  kind: ProductKind;
  productRootSubtype?: string | null;
  productType?: ProductType | null;
}

export const getDefaultProductPhoto = ({
  category,
  kind,
  productRootSubtype,
  productType,
}: Args) => {
  const strippedProductType =
    kind === 'flower'
      ? 'flower'
      : productType &&
        productType
          .toString()
          .replace(/[^0-9a-zA-Z]/g, '')
          .toLowerCase();

  const strippedProductRootType =
    productRootSubtype &&
    productRootSubtype.replace(/[^0-9a-zA-Z]/g, '').toLowerCase();

  // finalRootType is to account for the fact that all flower products have productType of category (see product.rb)
  // when the flower[strippedProductRootType] path doesn't exist in rootSubtypePaths, we use the flower's category as its rootType
  const finalRootType =
    strippedProductType === 'flower' &&
    !ROOT_SUBTYPE_PATHS[strippedProductType][strippedProductRootType || '']
      ? category
      : strippedProductRootType;

  if (
    strippedProductType &&
    finalRootType &&
    ROOT_SUBTYPE_PATHS[strippedProductType] &&
    ROOT_SUBTYPE_PATHS[strippedProductType][finalRootType]
  ) {
    return `${URL_ROOT}${strippedProductType}/${finalRootType}.png`;
  }

  return `${URL_ROOT}general/${strippedProductType}.png`;
};
